import apiService from './api';
import type { ApiResponse } from '../types';
import type { Part, PartFormData, PartsSearchResult } from '../types/parts';

interface ApiPaged<T>  { success: boolean; parts: T[]; total: number; page: number; totalPages: number; }

class PartsService {
  async search(
    q = '',
    filters: { category?: string; is_oem?: boolean; equipment_id?: number } = {},
    page = 1,
    limit = 20,
  ): Promise<PartsSearchResult> {
    const params = new URLSearchParams();
    if (q)                            params.set('q', q);
    if (filters.category)             params.set('category', filters.category);
    if (filters.is_oem !== undefined) params.set('is_oem', String(filters.is_oem));
    if (filters.equipment_id)         params.set('equipment_id', String(filters.equipment_id));
    params.set('page',  String(page));
    params.set('limit', String(limit));
    const res = await apiService.get(`/parts?${params.toString()}`) as unknown as ApiPaged<Part>;
    return {
      parts: res.parts || [],
      total: res.total || 0,
      page: res.page || 1,
      totalPages: res.totalPages || 1,
    };
  }

  async getById(id: number): Promise<ApiResponse<Part>> {
    return apiService.get(`/parts/${id}`);
  }

  async create(data: PartFormData): Promise<ApiResponse<Part>> {
    return apiService.post('/parts', data);
  }

  async update(id: number, data: Partial<PartFormData>): Promise<ApiResponse<Part>> {
    return apiService.put(`/parts/${id}`, data);
  }

  async addCompatibility(
    partId: number,
    data: {
      equipment_id?: number | null;
      make?: string | null;
      model?: string | null;
      year_from?: number | null;
      year_to?: number | null;
      engine_code?: string | null;
      notes?: string | null;
      equivalent_to_part_id?: number | null;
      source?: string;
      source_confidence?: 'high' | 'medium' | 'low' | null;
    },
  ): Promise<ApiResponse<unknown>> {
    return apiService.post(`/parts/${partId}/compatibility`, data);
  }

  async deleteCompatibility(compatId: number): Promise<ApiResponse<{ id: number }>> {
    return apiService.delete(`/parts/compatibility/${compatId}`);
  }
}

export const partsService = new PartsService();
export default partsService;
